"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.repairItemPrices = exports.checkJobStatus = void 0;
var _index = _interopRequireDefault(require("axios/index"));
var _moment = _interopRequireDefault(require("moment"));
var _itemDetails = require("./itemDetails");
var _pricingResource = require("../constants/pricingResource");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var repairItemPrices = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accessToken, itemIds, repairDateUseOrderDate, repairReason, reasonType, priceType) {
    var itemMappings, fulfillmentGroupIds, uniqueFulfillmentGroupIds, repairPriceType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(itemIds.map(function (itemId) {
              return (0, _itemDetails.getItemIdMappings)(itemId, accessToken);
            }));
          case 2:
            itemMappings = _context.sent;
            fulfillmentGroupIds = itemMappings.map(function (itemMapping) {
              var _itemMapping$_embedde;
              return (_itemMapping$_embedde = itemMapping._embedded.item[0]) === null || _itemMapping$_embedde === void 0 ? void 0 : _itemMapping$_embedde.fulfillmentGroupId;
            });
            uniqueFulfillmentGroupIds = _toConsumableArray(new Set(fulfillmentGroupIds)).map(function (id) {
              return {
                resourceType: "fulfillmentGroup",
                resourceId: id
              };
            });
            repairPriceType = priceType === _pricingResource.priceTypes.shippingPrice ? [_pricingResource.priceAssociationTypes.transferShippingPrice] : [_pricingResource.priceAssociationTypes.transferProductPrice, _pricingResource.priceAssociationTypes.manufacturingProductCostType];
            return _context.abrupt("return", _index["default"].post("https://pricerepair.cimpress.io/api/v1/priceRepairJobs", {
              priceTypesToRepair: repairPriceType,
              resources: uniqueFulfillmentGroupIds,
              repairErrorsOnly: true,
              effectiveDate: repairDateUseOrderDate ? null : (0, _moment["default"])().toISOString(),
              description: "Price Doctor UI - ".concat(reasonType, ": ").concat(repairReason)
            }, {
              headers: {
                'Authorization': "Bearer ".concat(accessToken)
              }
            }).then(function (response) {
              return response.data;
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function repairItemPrices(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();
exports.repairItemPrices = repairItemPrices;
var checkJobStatus = function checkJobStatus(accessToken, priceRepairJobId) {
  return _index["default"].get("https://pricerepair.cimpress.io/api/v1/priceRepairJobs/".concat(priceRepairJobId), {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data;
  });
};
exports.checkJobStatus = checkJobStatus;